import { Components } from 'formiojs';
var componentEditForm = Components.components.component.editForm;
import CaptchaProviders from './editForm/Captcha.edit.display';
export default function () {
    var extend = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        extend[_i] = arguments[_i];
    }
    return componentEditForm([
        {
            label: 'Display',
            key: 'display',
            components: CaptchaProviders
        },
        {
            key: 'data',
            ignore: true
        },
        {
            key: 'validation',
            ignore: true
        },
        {
            key: 'conditional',
            ignore: true
        },
        {
            key: 'logic',
            ignore: true
        },
        {
            key: 'api',
            ignore: true
        },
        {
            key: 'layout',
            ignore: true
        }
    ]);
}
